module.exports = "/assets/b7f31088bf815937ec193de101d5ca64.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WF.png
// module id = 3077
// module chunks = 0